/**
 * Format big counts the way social apps do — 1,234 → "1.2K", 1,000,000 → "1M".
 * Used for followers / following / likes counts so a profile with 100K+
 * followers doesn't break the layout with a 6-digit number.
 */
export function formatCount(n) {
  if (n == null || isNaN(n)) return "0";
  const num = Number(n);
  const abs = Math.abs(num);
  if (abs < 1000) return String(num);
  if (abs < 1_000_000) {
    // 1.2K, 12.5K, 999K — strip trailing .0
    const v = num / 1000;
    return (v % 1 === 0 ? v.toFixed(0) : v.toFixed(1).replace(/\.0$/, "")) + "K";
  }
  if (abs < 1_000_000_000) {
    const v = num / 1_000_000;
    return (v % 1 === 0 ? v.toFixed(0) : v.toFixed(1).replace(/\.0$/, "")) + "M";
  }
  const v = num / 1_000_000_000;
  return (v % 1 === 0 ? v.toFixed(0) : v.toFixed(1).replace(/\.0$/, "")) + "B";
}
